import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaFacebook, FaLinkedin } from "react-icons/fa";

const FooterWrapper = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  /* margin-top:2rem; */
  /* position: fixed;
  bottom:0;
  width:100%; */


  .footer__middle-section{
    display:flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 0 1rem 0;
  }

  .footer__missionText{
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
    line-height: 14px;
    text-align: center;
    letter-spacing: -0.204545px;
    color:var(--blue);
    margin-top: 1rem;

    @media only screen and (min-width:501px){
      font-size: 15px;
      line-height: 22px;
      margin-top: 2rem;
      /* margin-left:40px; */
    }
  }

  .footer__copyright{
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 9px;
    line-height: 14px;
    margin-top: 1rem;
    /* identical to box height */

    text-align: center;
    letter-spacing: -0.204545px;
    opacity: 0.35;
    color: var(--blue);

    @media only screen and (min-width:501px){
      font-size: 15px;
      line-height: 22px;
      margin-top:50px;
      margin-bottom:50px;
    }

  }
`;
const MobileFooterInnerWrapper = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;

  @media only screen and (min-width:769px){
    display:none;
  }

`;
const QuickLinks = styled.div`
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 50px;
  row-gap:30px;
  margin: 1rem 0;
  

  .quickLink{
    text-decoration: none;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 15px;
    /* identical to box height */
    text-align: center;
    letter-spacing: -0.231818px;
    color: var(--blue);

    &:hover{
      color:var(--orange);
    }

    @media only screen and (min-width:501px){
      font-size: 15px;
      line-height: 22px;
    }
  }

  @media only screen and (min-width:769px){
    row-gap:20px;
    margin: 0;

    .quickLink{
      text-align: left;
    }

  }
`;

const SocialIcons = styled.div`
  display:flex;
  align-items: center;
  justify-content: center;

  .socialIcon{
    font-size:30px;
    color:var(--blue);
    margin: 0 1rem;

    &:hover{
      color: var(--orange);
    }

    @media only screen and (min-width:769px){
      font-size:24px;
      margin: 0 9px;
    }
  }

`;

const DesktopFooterInnerWrapper = styled.div`
  display:flex;
  align-items: center;
  flex-direction: column;
  width:100%;
  border-top: 1px solid var(--blue);

  .copyright__container{
    width: 100%;
    border-top: 1px solid var(--blue);
  }

  @media only screen and (max-width:768px){
    display:none;
  }
`;

const DesktopUpperRow = styled.div`
  width:100%;
  display:grid;
  max-width: 1440px;
  grid-template-columns: repeat(2,1fr);
  align-items: flex-start;
  /* display:flex;
  justify-content: space-evenly; */

  .desktopUpperRow__leftCol{
    display:flex;
    align-items: center;
    justify-content: space-around;
    padding: 4.3rem 4rem 0rem 4rem;

    @media only screen and (max-width: 1250px){
      flex-direction: column;
    }

    @media only screen and (max-width:900px){
      width:100%;
      padding: 4.3rem 0 4rem 0;
    }
  }
  
  .desktopUpperRow__rightCol{
    display:flex;
    align-items: baseline;
    justify-content: space-evenly;
    border-left: 1px solid var(--blue);
    padding: 4.3rem 4rem 4rem 4rem;

    @media only screen and (max-width:900px){
      width:100%;
      padding: 4.3rem 0 4rem 0;
      border-top: 1px solid var(--blue);
    }
  }

  .desktop__SocialIcons{
    display:flex;
    align-items: center;
    flex-direction: column;
    margin-left:0.5rem;
  }

  .desktop__Socialtext{
    width:100%;
    text-align: left;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.231818px;
    color: var(--blue);
    margin-bottom: 10px;
    padding-left: 1rem;
  }

  @media only screen and (max-width:900px){
    display:flex;
    flex-direction: column;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <DesktopFooterInnerWrapper>
        <DesktopUpperRow>
          <div className="upperRow__container">
            <div className="desktopUpperRow__leftCol">
              <StaticImage alt="FFG Logo" imgClassName="desktop_footer_logo" src="../assets/images/FFG_logo_text.png" />
              <p className='footer__missionText'>We develop and execute on strategies that work.</p>
            </div>
          </div>
          
          <div className="desktopUpperRow__rightCol">
            <QuickLinks>
              <Link className='quickLink' to="/">Home</Link>
              <Link className='quickLink' to="/case-studies">Case Studies</Link>
              <Link className='quickLink' to="/our-services">Our Services</Link>
              <Link className='quickLink' to="/careers">Careers</Link>
              <Link className='quickLink' to="/our-company">Our Company</Link>
              <Link className='quickLink' to="/contact-us">Contact Us</Link>
            </QuickLinks>

            <div className="desktop__SocialIcons">

              <p className='desktop__Socialtext'>Follow Us</p>

              <SocialIcons>
                {/* https://www.instagram.com/fullfunnelgrowth/ */}
                <a href="https://www.instagram.com/fullfunnelgrowth/"><AiOutlineInstagram className='socialIcon' /></a>
                {/* https://www.facebook.com/people/Full-Funnel-Growth/100083175909973/ */}
                <a href="https://www.facebook.com/people/Full-Funnel-Growth/100083175909973/"><FaFacebook className='socialIcon' /></a>
                {/* https://www.linkedin.com/company/full-funnel-growth */}
                <a href="https://www.linkedin.com/company/full-funnel-growth"><FaLinkedin className='socialIcon' /></a>
              </SocialIcons>
            </div>
          </div>
        </DesktopUpperRow>
        <div className="copyright__container">
          <p className='footer__copyright'>Copyright &copy; 2022. Full Funnel Growth. All rights reserved.</p>
        </div>

      </DesktopFooterInnerWrapper>

      <MobileFooterInnerWrapper>
        <StaticImage alt="FFG Logo" src="../assets/images/FFG_logo_text.png" />
        <p className='footer__missionText'>We develop and execute on strategies that work.</p>

        <div className="footer__middle-section">
          <QuickLinks>
            <Link className='quickLink' to="/">Home</Link>
            <Link className='quickLink' to="/case-studies">Case Studies</Link>
            <Link className='quickLink' to="/our-services">Our Services</Link>
            <Link className='quickLink' to="/careers">Careers</Link>
            <Link className='quickLink' to="/our-company">Our Company</Link>
            <Link className='quickLink' to="/contact-us">Contact Us</Link>
          </QuickLinks>
          <p className='footer__copyright'>Copyright &copy; 2022. Full Funnel Growth. All rights reserved.</p>
        </div>

        {/* {social icons} */}
        <SocialIcons>
          {/* https://www.instagram.com/fullfunnelgrowth/ */}
          <a href="https://www.instagram.com/fullfunnelgrowth/"><AiOutlineInstagram className='socialIcon' /></a>
          {/* https://www.facebook.com/people/Full-Funnel-Growth/100083175909973/ */}
          <a href="https://www.facebook.com/people/Full-Funnel-Growth/100083175909973/"><FaFacebook className='socialIcon' /></a>
          {/* https://www.linkedin.com/company/full-funnel-growth */}
          <a href="https://www.linkedin.com/company/full-funnel-growth"><FaLinkedin className='socialIcon' /></a>
        </SocialIcons>

      </MobileFooterInnerWrapper>
    </FooterWrapper>
  );
};

export default Footer;